"use client";

import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActiveTab } from "../../store/tabSlice";
import styles from "./HairdresserCard.module.css";
import { ReactComponent as PartnersArrow } from "../../assets/icons/PartnersArrow.svg";
import classNames from "classnames";
import moment from "moment-jalaali";
import "moment/locale/fa";

interface HairdresserCardProps {
  title: string;
  firstname: string;
  lastname: string;
  availability: string | null;
  firstFreeTime: string | null;
  id: number;
}

const HairdresserCard: React.FC<HairdresserCardProps> = React.memo(
  ({ title, firstname, lastname, id, firstFreeTime }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleHairdresserClick = useCallback(() => {
      const fullName = `${firstname} ${lastname}`;
      dispatch(setActiveTab("appointments"));
      navigate(`/times?partnerId=${id}&stylist=${encodeURIComponent(fullName)}&date=${firstFreeTime}`);



    }, [firstname, lastname, id, navigate, dispatch]);

    // ⬇️ آماده‌سازی فرمت تاریخ (شمسی)
    moment.loadPersian({ usePersianDigits: false });
    const formattedFirstFreeTime = firstFreeTime && moment(firstFreeTime).isValid()
    ? (() => {
        const date = moment(firstFreeTime);
        return `${date.jDate()} ${date.format("jMMMM")}`;
      })()
    : "نامشخص";
  

    return (
      <div
        className={classNames("card border-0 text-center rounded-4", styles.card)}
        onClick={handleHairdresserClick}
        style={{ cursor: "pointer" }}
      >
        <p className={styles.title}>{title || "بدون عنوان"}</p>

        <h4 className={classNames(styles.name)}>
          {`${firstname} ${lastname}` || "نامشخص"}
        </h4>

        <div className={styles.availabilityContainer}>
          <div className={styles.icon}>
            <PartnersArrow className={styles.partnersIcon} />
          </div>
          <div className={styles.textContainer}>
            <p className={styles.textSmall}>اولین وقت خالی:</p>
            <p className={styles.textLarge}>{formattedFirstFreeTime}</p>
          </div>
        </div>
      </div>
    );
  }
);

export default HairdresserCard;
